/**
 * The 25 natures. Each raises one stat by 10% and lowers another by 10%;
 * the five where up === down are neutral. HP is never affected.
 */
export const STAT_LABEL = {
  atk: 'Attack',
  def: 'Defense',
  spa: 'Sp. Atk',
  spd: 'Sp. Def',
  spe: 'Speed',
};

export const NATURES = [
  { name: 'Hardy', up: 'atk', down: 'atk' },
  { name: 'Lonely', up: 'atk', down: 'def' },
  { name: 'Brave', up: 'atk', down: 'spe' },
  { name: 'Adamant', up: 'atk', down: 'spa' },
  { name: 'Naughty', up: 'atk', down: 'spd' },
  { name: 'Bold', up: 'def', down: 'atk' },
  { name: 'Docile', up: 'def', down: 'def' },
  { name: 'Relaxed', up: 'def', down: 'spe' },
  { name: 'Impish', up: 'def', down: 'spa' },
  { name: 'Lax', up: 'def', down: 'spd' },
  { name: 'Timid', up: 'spe', down: 'atk' },
  { name: 'Hasty', up: 'spe', down: 'def' },
  { name: 'Serious', up: 'spe', down: 'spe' },
  { name: 'Jolly', up: 'spe', down: 'spa' },
  { name: 'Naive', up: 'spe', down: 'spd' },
  { name: 'Modest', up: 'spa', down: 'atk' },
  { name: 'Mild', up: 'spa', down: 'def' },
  { name: 'Quiet', up: 'spa', down: 'spe' },
  { name: 'Bashful', up: 'spa', down: 'spa' },
  { name: 'Rash', up: 'spa', down: 'spd' },
  { name: 'Calm', up: 'spd', down: 'atk' },
  { name: 'Gentle', up: 'spd', down: 'def' },
  { name: 'Sassy', up: 'spd', down: 'spe' },
  { name: 'Careful', up: 'spd', down: 'spa' },
  { name: 'Quirky', up: 'spd', down: 'spd' },
];
